import { mapGetters, mapActions } from 'vuex'
import manuscript from '../../../../api/manuscript'

export default {
  data() {
    return {
      rules: {},
      params: {
        reviewerList: [],
        suList: [],
        opList: []
      }
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      manuscript: 'getManuscript'
    })
  },
  watch: {
    manuscript: {
      handler(val) {
        if (val.id) {
          let { reviewerList, version, sign, id } = val
          this.params = {
            version,
            sign,
            id,
            suList: [],
            opList: []
          }
          reviewerList = reviewerList || []
          this.params.reviewerList = reviewerList
          if (reviewerList.length) {
            reviewerList.forEach(item => {
              if (item.type === 'SUGGEST') {
                this.params.suList.push(item)
              } else if (item.type === 'OPPOSE') {
                this.params.opList.push(item)
              }
            })
          } else {
            this.params.suList.push({
              firstName: '',
              lastName: '',
              email: '',
              affiliation: ''
            })
            this.params.opList.push({
              firstName: '',
              lastName: '',
              email: '',
              affiliation: ''
            })
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getRules()
  },
  methods: {
    ...mapActions(['updateManuscript']),
    async submit() {
      this.params.reviewerList = []
      this.params.suList.forEach(item => {
        if (item.email || item.firstName || item.lastName || item.affiliation) {
          this.params.reviewerList.push(
            Object.assign(item, { type: 'SUGGEST' })
          )
        }
      })
      this.params.opList.forEach(item => {
        if (item.email || item.firstName || item.lastName || item.affiliation) {
          this.params.reviewerList.push(Object.assign(item, { type: 'OPPOSE' }))
        }
      })
      const res = await manuscript.step4(this.params)

      this.updateManuscript(res)
      this.$router.push('step5?id=' + res.id)
    },
    async skip() {
      let { version, sign, id } = this.manuscript
      const res = await manuscript.step4({
        reviewerList: [],
        suList: [],
        opList: [],
        version,
        sign,
        id
      })

      this.updateManuscript(res)
      this.$router.push('step5?id=' + this.manuscript.id)
    },
    addMore(key) {
      this.params[key].push({
        firstName: '',
        lastName: '',
        email: '',
        affiliation: ''
      })
    },
    del(key, index) {
      this.params[key].splice(index, 1)
    },
    getRules() {
      this.rules = {
        email: [
          {
            type: 'email',
            message: this.LANGUAGE[this.language].enterCorrent + 'Email'
          }
        ]
      }
    }
  }
}
